import get from 'lodash/get';
import { selectCurrentJourneyConfig } from '@/services/selectors';
import { BackofficeUserModel } from '@/typings/api/user';
import { checkUserAccessToPath } from '@/utils/access';

type MenuState = { currentUser?: BackofficeUserModel; selectedSolution?: string };

export const filterMenu = (initialState: MenuState, menuData) => {
  const user = initialState?.currentUser;
  const selectedSolution = initialState.selectedSolution;
  const journeyConfig = selectCurrentJourneyConfig(window.getState());
  return menuData.flatMap(menu => {
    const { path, solution, journeyConfigAccessKey } = menu;
    const hasUserAccess = checkUserAccessToPath(user, path);
    if (!hasUserAccess) return [];

    if (solution && selectedSolution !== solution) return [];

    if (journeyConfigAccessKey) {
      return get(journeyConfig, journeyConfigAccessKey) ? [menu] : [];
    }

    if (Array.isArray(menu.children) && menu.children.length > 0) {
      const children = filterMenu(initialState, menu.children);
      // Every child was filtered out. pro-layout renders a childless group as a
      // plain item linking to the group's own path (BaseMenu only builds a
      // SubMenu when children.length > 0), and no group route has a page behind
      // it — so the group has to go with its children.
      if (children.length === 0) return [];
      // A copy: pro-layout passes the same objects on every render, and trimming
      // them in place left `children: []`, so the group came back as a bare link.
      return [{ ...menu, children }];
    }
    return [menu];
  });
};
